<script lang="ts">
    import { shorten } from "../utils/text";
    import { primary, red, green } from "../theme";
    import type { ConstraintDescriptor } from "../types";

    export let feat: string;
    export let visible: boolean;
    export let highlight: boolean;
    export let constraints: ConstraintDescriptor[] = [];

    $: stroke = getStroke(satisfied(feat, constraints));

    const satisfied = (
        feat: string,
        constraints: ConstraintDescriptor[]
    ): boolean => {
        const featConstraints = constraints.filter(
            (c) => c.selected && (c.f1 === feat || c.f2 === feat)
        );
        if (featConstraints.length <= 0) {
            return null;
        }
        return featConstraints.every((c) => c.satisfied);
    };

    const getStroke = (satisfied: boolean) => {
        if (satisfied === null) {
            return null;
        }
        if (satisfied) {
            return green;
        }
        return red;
    };

    const size = 56;
    const radius = 24;
    $: shadowRadius = highlight ? 6 : 2;
    $: shadow = `drop-shadow(0px 0px ${shadowRadius}px ${primary})`;
</script>

<svg width={size} height={size} overflow="visible">
    <g>
        <g visibility={visible ? "visible" : "hidden"}>
            <circle
                cx={size / 2}
                cy={size / 2}
                r={radius}
                {stroke}
                stroke-width={4}
                class="node"
                style="filter: {shadow}"
            />
            <text x={size / 2} y={size / 2} font-size="14" class="node-text"
                >{shorten(feat)}</text
            >
        </g>
    </g>
</svg>

<style lang="scss">
    @import "theme.scss";

    .node {
        fill: $primary;
    }

    .node-text {
        text-anchor: middle;
        dominant-baseline: central;
    }
</style>
